/* src/app/shared/contract/contract-item/contract-comment/contract-comment.component.scss */
.tv-ns-primary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  gap: 5px;
  font: 700 13px FranceTV Brown;
  background-color: #F03C64;
  border: 1px solid #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-light-bg:hover {
  background-color: #CC3456;
  border: 1px solid #CC3456;
}
.tv-ns-primary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-primary-large-button-on-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  gap: 5px;
  font: 700 13px FranceTV Brown;
  border: 1px solid #F03C64;
  background-color: #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-dark-bg:hover {
  border: 1px solid #F03C64;
  background-color: transparent;
}
.tv-ns-primary-large-button-on-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-secondary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  gap: 5px;
  font: 700 13px FranceTV Brown;
  background-color: #FFF;
  color: #244666;
  border: 1px solid #244666;
}
.tv-ns-secondary-large-button-on-light-bg:hover {
  background-color: #244666;
  border: 1px solid #244666;
  color: #FFF;
}
.tv-ns-secondary-large-button-on-light-bg:hover svg path {
  fill: #FFF !important;
}
.tv-ns-secondary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-secondary-large-button-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  gap: 5px;
  font: 700 13px FranceTV Brown;
  background-color: transparent;
  color: #DFEBF7;
  border: 1px solid #DFEBF7;
}
.tv-ns-secondary-large-button-dark-bg:hover {
  border: 1px solid #DFEBF7;
  background-color: #DFEBF7;
  color: #244666;
}
.tv-ns-secondary-large-button-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-validation-large-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  gap: 5px;
  font: 700 13px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-large-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-large-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-validation-small-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-small-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-validation-small-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-small-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-small-blue-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #0083FF;
  border: 1px solid #0083FF;
  color: #FFF;
}
.tv-ns-small-blue-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-small-blue-button:hover {
  background-color: #FFF;
  border: 1px solid #0083FF;
  color: #0083FF;
}
.tv-ns-small-blue-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.light-flex-card {
  background-color: #FFF;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  margin-bottom: 20px;
}
.sub-title {
  font: 700 16px FranceTV Brown;
  color: #001A33;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 20px;
  margin: 0;
  border-radius: 5px;
  background-color: #F2F9FF;
}
.item {
  background-color: white;
  border-radius: 5px;
  padding: 15px;
}
.item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font: 400 12px FranceTV Brown;
}
.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}
.item-header .title {
  width: 200px;
}
.item-header .date-range {
  width: 120px;
}
.item-header .ca {
  width: 60px;
}
.item-options {
  display: flex;
  align-items: center;
  min-width: 500px;
  max-width: 75%;
  overflow-y: auto;
}
.item-options .option-type-icon {
  height: 16px;
  margin-right: 5px;
}
.option-products {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 2px;
  margin-right: 20px;
}
.item-actions {
  display: flex;
  align-items: center;
  gap: 25px;
}
.item-actions mat-icon {
  cursor: pointer;
  color: rgba(107, 144, 179, 0.3);
}
.comment-container {
  background-color: rgba(36, 70, 102, 0.05);
  border-radius: 5px;
  padding: 15px;
  max-height: 400px;
  overflow-y: auto;
}
.comment-container::-webkit-scrollbar {
  width: 12px;
}
.comment-container::-webkit-scrollbar-thumb {
  background-color: rgba(107, 144, 179, 0.3);
  border-radius: 10px;
  border: 3px solid #F2F9FF;
}
.comment-container::-webkit-scrollbar-track {
  background-color: #DFEBF7;
  border-radius: 10px;
}
.comment-card {
  background-color: #FFF;
  border-radius: 10px;
  padding: 20px;
}
.card-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.comment-item {
  margin: 5px;
  padding: 5px;
}
.comment-card-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.add {
  margin-right: 20px;
}
.filters-div {
  margin-left: 20px;
  margin-right: 20px;
}
.no-comments {
  color: #001A33;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font: 500 10px FranceTv Brown;
  text-align: center;
}
.mat-expansion-panel-header {
  height: 58px;
  padding: 0 15px 0 10px;
}
.mat-expansion-indicator {
  background-color: black;
}
.header-item-filters {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}
.comment-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.action-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}
.body {
  font: 400 14px FranceTV Brown;
  color: #6B90B3;
}
.mat-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.comment-left {
  color: #001A33;
  display: flex;
  align-items: center;
  gap: 15px;
  min-width: 0;
}
.comment-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-width: 0;
}
.edited-by {
  font: 700 12px FranceTV Brown;
  color: #6B90B3;
  white-space: nowrap;
}
.comment-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  flex: 1;
}
.author,
.comment-date {
  color: #001A33;
}
.comment-type-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  min-width: 124px;
  padding: 0 10px;
  border-radius: 999px;
  font: 700 12px FranceTV Brown;
  letter-spacing: 0.2px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid transparent;
}
.comment-type-badge.classic {
  color: #00D78C;
  background-color: rgba(0, 215, 140, 0.1);
  border-color: #00D78C;
}
.comment-type-badge.digital {
  color: #0083FF;
  background-color: rgba(0, 131, 255, 0.1);
  border-color: rgba(0, 131, 255, 0.2);
}
.comment-type-badge.parrainage {
  color: #FFC946;
  background-color: rgba(255, 201, 70, 0.1);
  border-color: rgba(255, 201, 70, 0.2);
}
.comment-type-badge.unknown {
  color: #6B90B3;
  background-color: rgba(107, 144, 179, 0.1);
  border-color: rgba(107, 144, 179, 0.2);
}
/*# sourceMappingURL=contract-comment.component.css.map */
